window.$mm_management_units_webgisId = "";
window.$mm_management_units_selectedRow = "";
window.$mm_management_units_content = [];
window.$mm_management_units_algemeenGisratioid = [];
window.$mm_management_units_beheereenheidNaam = [];
window.$mm_management_units_disciplineNaam = [];
window.$mm_management_units_gebiedNaam = [];
window.$mm_management_units_algemeenLaag = [];
window.$mm_management_units_scroll_change = false;
window.$mm_management_units_result = [];
window.$mm_management_units_gvv = 1;
window.$mm_management_units_filterMaatregelenIsActive = [];
window.$mm_management_units_filterPlannigIsActive = [];
window.$mm_management_units_filterContent = [];
window.$mm_management_units_filterClickStatus = false;
window.$mm_management_units_filterCheckControl = [false, false];
window.$mm_management_units_text_search = null;
window.$mm_management_units_sorting = null;
window.$mm_management_units_page_number = 1;
window.$mm_management_units_maat_page_number = 1;
window.$mm_management_units_patronen_page_number = 1;
window.$mm_management_units_perioden_page_number = 1;
window.$mm_management_units_cat_beheerenden_page_number = 1;
window.$mm_management_units_Glist = [];
window.$mm_management_units_Glist_FilterContainer = [];
window.$mm_management_maatregelPageNUmber = 1;
window.$mm_management_werkplanPageNUmber = 1;
window.$mm_management_budgetPageNUmber = 1;
window.$mm_management_organisatiePageNUmber = 1;
window.$mm_management_units_token = null;
window.$mm_management_units_table_total_row_count = 0;
window.$mm_management_units_columnList = [];
window.$mm_management_units_columnListPure = null;
window.$mm_management_units_context = null;
window.$mm_management_units_refresh = function (){};
window.$mm_management_units_lastUsedTableFilter = {
  content: [],
  definitions: [],
  instance_identifications: window.$set_selected_button_selected_ids
};
window.$mm_management_units_lastUsedTableFilterModal = {
  content: [],
  definitions: [],
  instance_identifications: window.$set_selected_button_selected_ids
};
window.$mm_management_units_column_order_users = {
  client_identification: "",
  code: "",
  data: {
    users: [],
  },
};
window.$mm_management_units_column_order_post_model = {
  client_identification: "",
  code: "",
  data: {
    table_sorting: [
      {
        name: "mm>management-units",
        column_list: [
          "checkbox",
          "active",
          "Gisratio ID",
          "Naam beheereenheid",
          "Discipline naam",
          "Horizon",
          "GIS laag naam",
          "Prestatie",
          "Gebiedsnaam",
        ],
      },
    ],
  },
};
window.$mm_management_units_definitionList = [
  { id: process.env.REACT_APP_MM_M_UNITS, name: "beheerobjecten" },
  { id: process.env.REACT_APP_GEBIEDEN, name: "gebieden" },
  { id: process.env.REACT_APP_MM_MEASURES, name: "maatregelen" },
  { id: process.env.REACT_APP_PLANNINGSPATRONEN, name: "planningspatronen" },
  { id: process.env.REACT_APP_PLANNINGSPERIODEN, name: "planningsperioden" },
  { id: process.env.REACT_APP_CATALOG_DISCIPLINE, name: "discipline" },
  { id: process.env.REACT_APP_CATALOG_MEASURES, name: "maatregelnames" },
];
window.$mm_management_units_actions = [
  {
    id: "PLAATS_IN_GEBIED",
    text: "Plaats in gebied",
    class: "locate",
    modal: "gebied_plaatsen",
  },
  {
    id: "WIJZIG_DISCIPLINE",
    text: "Wijzigen discipline",
    class: "locate",
    modal: "discipline_wijzigen",
  },
  {
    id: "TOEVOEGEN_MAATREGEL",
    text: "Toevoegen maatregel",
    class: "locate",
    modal: "beheeractiviteit_toevoegen",
  },
  {
    id: "AANMAKEN_CORRECTIEF_ONDERHOUD",
    text: "Aanmaken correctief onderhoud",
    class: "locate",
    modal: "correctief_onderhoud",
  },
  {
    id: "mu_toon_dossiers_op_kaart",
    text: "mu_toon_dossiers_op_kaart",
    class: "locate",
    modal: "",
  },
  {
    id: "mu_overzicht_object",
    text: "mu_overzicht_object",
    class: "",
    modal: "overzicht_object",
  },
];

/*window.$mm_management_units_actions = [
  {
    id: "94ea165f-4df5-4fad-8566-41b42eb8d493",
    text: "Plaats in gebied",
    class: "locate",
    modal: "gebied_plaatsen",
  },
  {
    id: "3dcddc6d-77da-4b4b-8f48-534241a3804e",
    text: "Wijzigen discipline",
    class: "locate",
    modal: "discipline_wijzigen",
  },
  {
    id: "9f579fe7-e03c-4e61-ac1b-a724b1d61229",
    text: "Toevoegen maatregel",
    class: "locate",
    modal: "beheeractiviteit_toevoegen",
  },
  {
    id: "08dd5290-f3bb-44f8-8331-6501d0ed6f2a",
    text: "Aanmaken correctief onderhoud",
    class: "locate",
    modal: "correctief_onderhoud",
  },
  {
    id: "mu_toon_dossiers_op_kaart",
    text: "mu_toon_dossiers_op_kaart",
    class: "locate",
    modal: "",
  },
  {
    id: "mu_overzicht_object",
    text: "mu_overzicht_object",
    class: "",
    modal: "overzicht_object",
  },
];*/
